<template>
  <div class="wrap">正在跳转到公开入驻页…</div>
</template>

<script setup lang="ts">
import { buildAgentApplyInviteUrl } from '@/api/agent/portal'

defineOptions({ name: 'AgentApplyPublicRedirect' })

const route = useRoute()
onMounted(() => {
  const q: Record<string, string> = {}
  Object.entries(route.query).forEach(([k, v]) => {
    if (typeof v === 'string') q[k] = v
    else if (Array.isArray(v) && v[0]) q[k] = String(v[0])
  })
  window.location.replace(buildAgentApplyInviteUrl(q))
})
</script>

<style scoped>
.wrap {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>
